import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { EditWorkplaceModalStore } from './edit-workplace-modal.store';
import { FolderWorkplaceGridItemObject } from '@libs/types/src/services/object-type/folder-workplace.object';
import { FormBuilder, Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { dateify } from '../../../../../shared/helpers/date.helper';
import { FolderWorkplaceUpdateInput } from '@libs/types/src/services/input-type/services/folder-workplace-update.input';
import { FolderWorkplaceCreateInput } from '@libs/types/src/services/input-type/services/folder-workplace.create-input';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import { AsyncPipe } from '@angular/common';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-edit-workplace-modal',
    templateUrl: 'edit-workplace-modal.component.html',
    styleUrl: 'edit-workplace-modal.component.scss',
    providers: [EditWorkplaceModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        SelectInputComponent,
        AsyncPipe,
        DateInputComponent,
        ActionButtonsComponent,
        PrimeTemplate,
    ],
})
export class EditWorkplaceModalComponent extends SubscriptionComponent {

    protected readonly store = inject(EditWorkplaceModalStore);
    private readonly fb = inject(FormBuilder);

    protected workplace: FolderWorkplaceGridItemObject | null = null;
    protected err: string | null = null;

    protected form = this.fb.group({
        workplaceId: this.fb.control<number | null>(null, Validators.required),
        dateFrom: this.fb.control<Date | null>(null),
        dateTo: this.fb.control<Date | null>(null),
    });
    protected visible: boolean = false;

    constructor() {
        super();
        this.store.registerSuccessMessage('updateFolderWorkplace', 'workplace.message.updated');
        this.store.registerSuccessMessage('createFolderWorkplace', 'workplace.message.created');
    }

    public show(visible: boolean = true): void {
        this.visible = visible;
    }

    public async save(): Promise<void> {
        this.err = null;
        if (isInvalid(this.form)) return;

        const { dateTo, dateFrom } = this.form.value;
        if (dateTo && dateFrom && dateFrom > dateTo) {
            this.err = 'errors.DATE_FROM_PRECEDES_DATE_TO';
            return;
        }

        const _data = {
            ...this.form.value,
        } as any;

        if (this.workplace?.id) {
            const data = _data as FolderWorkplaceUpdateInput;
            data.id = this.workplace.id;
            this.store.api.updateFolderWorkplace(data);
        } else {
            const data = _data as FolderWorkplaceCreateInput;
            data.folderId = Number(this.store.routeParam.folderId.value);
            this.store.api.createFolderWorkplace(data);
        }

        this.show(false);
        this.form.reset();
    }

    public editWorkplace(workplace: FolderWorkplaceGridItemObject | null = null): void {
        this.workplace = workplace;
        if (workplace) {
            this.form.patchValue({
                workplaceId: workplace.workplaceId,
                dateFrom: dateify(workplace.dateFrom),
                dateTo: dateify(workplace.dateTo),
            });
        }
        this.show();
    }

}
